import {
  Modal,
  PrimaryBlueButton,
  PrimaryGrayButton,
  Toggle
} from "@velaro/velaro-component-lib";
import React, { useState } from "react";
import AIChatbotSettingsRow from "./AIChatbotSettingsRow";
import { AzureIndex } from "../types";
import AIChatbotSettingsRowToggle from "./AIChatbotSettingsRowToggle";
import useSubscriptions from "@/hooks/useSubscriptions";
import useAzureIndexes from "@/hooks/useAzureIndexes";

interface Props {
  id: number;
  clearDeleteModal(): void;
  deleteIndex(id: number): void;
}

export default function DeleteIndexModal(props: Props) {
  const { azureIndexes, loading, remove } = useAzureIndexes();
  const { subscription } = useSubscriptions();
  return (
    <Modal maxWidth="max-w-3xl" show={true}>
      <div className="bg-white p-4 rounded-2xl w-full self-center mt-4">
        <div className="font-semibold text-lg pb-1">Delete Index</div>
        <div className="text-slate-500 text-sm pb-2">
          Are you sure you want to delete the index?
        </div>
        <div className="flex justify-end mt-2 gap-6">
          <PrimaryGrayButton
            label="Cancel"
            onClick={() => props.clearDeleteModal()}
          />
          <PrimaryBlueButton
            label="Delete"
            onClick={() => props.deleteIndex(props.id)}
          />
        </div>
      </div>
    </Modal>
  );
}
